/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider } from "@mantine/core";

export default function OtherLegalRequirementsCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={4}>Other legal requirements</Title>
      <Divider my="md" />
      <Text>
        The Company may disclose Your Personal Data in the good faith belief
        that such action is necessary to:
      </Text>

      <ul style={{ marginTop: 12 }}>
        <li>Comply with a legal obligation</li>
        <li>Protect and defend the rights or property of the Company</li>
        <li>
          Prevent or investigate possible wrongdoing in connection with the
          Service
        </li>
        <li>
          Protect the personal safety of Users of the Service or the public
        </li>
        <li>Protect against legal liability</li>
      </ul>
    </Card>
  );
}
